import React from 'react';

const Logo: React.FC<{ size?: number; className?: string }> = ({ size = 28, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    className={className}
    aria-label="GitHubMate logo"
  >
    <rect x="8" y="8" width="84" height="84" rx="22" fill="#9FE870" />
    <path d="M32 38 h30 v34 a7 7 0 0 1 -7 7 h-16 a7 7 0 0 1 -7 -7 z" stroke="#0C0E0D" strokeWidth="6" strokeLinejoin="round" />
    <path d="M62 45 h5 a7 7 0 0 1 7 7 v4 a7 7 0 0 1 -7 7 h-5" stroke="#0C0E0D" strokeWidth="6" strokeLinecap="round" />
    <path d="M28 36 c0 -6 6 -9 10 -6 c1 -6 10 -7 12 -1 c5 -4 12 0 11 7" stroke="#0C0E0D" strokeWidth="6" strokeLinecap="round" fill="none" />
    <line x1="41" y1="50" x2="41" y2="66" stroke="#0C0E0D" strokeWidth="6" strokeLinecap="round" />
    <line x1="52" y1="50" x2="52" y2="66" stroke="#0C0E0D" strokeWidth="6" strokeLinecap="round" />
  </svg>
);

export default Logo;
